module.exports = __webpack_public_path__ + "static/media/mini.ee7b985e.svg";